
export default {

  setSettings (state, settings) {
    state.current = settings
  }
}